import { Box, IconButton, InputAdornment } from '@mui/material';
import { RHFTextField } from '../hook-form';

import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persianFa from 'react-date-object/locales/persian_fa';
import 'react-multi-date-picker/styles/colors/green.css';
import Iconify from '../Iconify';

const GeneralDatePicker = ({ label, name, value, onChangeValue, minDate, maxDate, resetable = false, resetDateHandler,...rest }) => {
  return (
    <DatePicker
      value={value}
      onChange={onChangeValue}
      calendar={persian}
      locale={persianFa}
      calendarPosition="bottom-right"
      zIndex={99999}
      format="YYYY/MM/DD"
      minDate={minDate}
      maxDate={maxDate}
      monthYearSeparator="|"
      className="green"
      defaultValue={new Date()}
      fixMainPosition
      style={{
        fontFamily: 'IR-Yekan',
      }}
      render={(value, openCalendar) => (
        <RHFTextField
          name={name}
          value={value}
          type="text"
          label={label}
          onClick={openCalendar}
          autoComplete="off"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {resetable ? (
                  <IconButton onClick={resetDateHandler}>
                    <Iconify icon={'carbon:close-filled'} />
                  </IconButton>
                ) : null}
                <Box
                  component="span"
                  sx={{
                    width: 24,
                    height: 24,
                    display: 'inline-block',
                    bgcolor: 'currentColor',
                    mask: `url("/icons/ic_calendar.svg") no-repeat center / contain`,
                    WebkitMask: `url("/icons/ic_calendar.svg") no-repeat center / contain`,
                  }}
                />
              </InputAdornment>
            ),
          }}
        />
      )}
      {...rest}
    />
  );
};

export default GeneralDatePicker;
